import { useEffect, useState } from "react"
import styled from "styled-components"
import { FullScreenLoadingCover, SelectDropdown } from "@prosolve/common-components-ui"
import useDataJobs from "../../dataHooks/useDataJobs"
import EmailModal from "./EmailModal"

const RowGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const HR = styled.div`
  border-top: solid 1px silver;
  margin: 10px 0;
`

export default ({
  attendee,
  onClose
}) => {
  const [emailType, setEmailType] = useState(attendee?.emailType)

  const { isLoading, composeAttendeesEventReminderEmail, fetchComposeAttendeeEventReminderEmail } = useDataJobs()

  useEffect(() => {
    fetchComposeAttendeeEventReminderEmail({ attendee: { ...attendee, emailType } })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailType])

  return (
    <>
      {
        isLoading || !composeAttendeesEventReminderEmail
        ?
        <FullScreenLoadingCover />
        :
        <EmailModal email={composeAttendeesEventReminderEmail} onClose={onClose} header={
          <>
            <RowGroup>
              <strong>Email Type: </strong>
              <SelectDropdown 
                width='200px' 
                value={emailType}
                onChange={selected => setEmailType(selected)} 
                options={[
                  { text: 'Default', value: '' },
                  { text: 'Quest In Person', value: 'QUEST_IN_PERSON' },
                  { text: 'Quest Virtual', value: 'QUEST_VIRTUAL' },
                  { text: 'Sled In Person', value: 'SLED_IN_PERSON' },
                  { text: 'Sled Virtual', value: 'SLED_VIRTUAL' },
                  { text: 'Unlock In Person', value: 'UNLOCK_IN_PERSON' },
                ]} 
              />
            </RowGroup>

            <HR />
          </>
        } />
      }
    </>
  )
}
